import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./PrivacyPolicy.css";
import HeroSection from "../../components/heroSection/HeroSection";
import Footer from "../../components/footer/Footer";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[id^="section-"]');
      const scrollPosition = window.scrollY + 150;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute("id");

        if (
          scrollPosition >= sectionTop &&
          scrollPosition < sectionTop + sectionHeight
        ) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); 

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSidebarClick = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 100;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
      setActiveSection(sectionId);
    }
  };

  const handleNavClick = (path) => {
    navigate(path);
  };

  const handleLogin = () => {
    navigate("/onboarding");
  };

  const handleGetStarted = () => {
    navigate("/onboarding");
  };

  const renderListItem = (text, className = "") => (
    <div className={`privacy_policy_list_item ${className}`}>{text}</div>
  );

  const getHeroDescription = () => {
    return "We are committed to protecting your privacy. This Privacy Policy applies to all our associated applications owned and controlled by us. This Privacy Policy governs our data collection, processing and usage practices.";
  };

  return (
    <div className="privacy_policy_page">
      <HeroSection
        title="Privacy Policy"
        description={getHeroDescription()}
        showDecorative={true}
        variant="privacy"
        activeNav="privacy"
        onNavClick={handleNavClick}
        onLoginClick={handleLogin}
        onGetStartedClick={handleGetStarted}
      />

      <div className="privacy_policy_main_content">
        <div className="privacy_policy_sidebar_and_content">
          <aside className="privacy_policy_sidebar">
            <h3 className="privacy_policy_sidebar_title">
              Privacy Policy Content
            </h3>
            <nav className="privacy_policy_sidebar_nav">
              <a
                href="#section-1"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-1" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-1")}
              >
                1. Use of Service by Customers
              </a>
              <a
                href="#section-2"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-2" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-2")}
              >
                2. Unsubscribe from Communications
              </a>
              <a
                href="#section-3"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-3" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-3")}
              >
                3. Corrections of Personal Information
              </a>
              <a
                href="#section-4"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-4" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-4")}
              >
                4. Information We Collect
              </a>
              <a
                href="#section-5"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-5" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-5")}
              >
                5. How We Use Information
              </a>
              <a
                href="#section-6"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-6" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-6")}
              >
                6. Sharing Your Personal Information
              </a>
              <a
                href="#section-7"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-7" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-7")}
              >
                7. Transfer of Information
              </a>
              <a
                href="#section-8"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-8" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-8")}
              >
                8. Security of Personal Information
              </a>
              <a
                href="#section-9"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-9" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-9")}
              >
                9. Cookies and Technologies
              </a>
              <a
                href="#section-10"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-10" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-10")}
              >
                10. Data Retention
              </a>
              <a
                href="#section-11"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-11" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-11")}
              >
                11. Your Rights
              </a>
              <a
                href="#section-12"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-12" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-12")}
              >
                12. Contact Us
              </a>
              <a
                href="#section-13"
                className={`privacy_policy_sidebar_link ${
                  activeSection === "section-13" ? "active" : ""
                }`}
                onClick={(e) => handleSidebarClick(e, "section-13")}
              >
                13. Governing Law
              </a>
            </nav>
          </aside>

          <div className="privacy_policy_content_area">
            <div className="privacy_policy_updated_badge">
              Updated November 26, 2025
            </div>

            <div className="privacy_policy_intro_section">
              <p className="privacy_policy_paragraph">
                We will post any privacy policy changes on this page and, if the
                changes are significant, we will provide a more prominent notice
                by sending you an email notification.
              </p>
            </div>

            {/* Section 1: Use of Service */}
            <section className="privacy_policy_section" id="section-1">
              <h2 className="privacy_policy_section_header">
                1. Use of Service By Our Customers
              </h2>
              <p className="privacy_policy_paragraph">
                When you visit the Websites or register for the Subscription
                Service, we may request that you provide Personal Information
                about yourself, and we collect Navigational Information. Your
                information is also collected when you:
              </p>
              <div className="privacy_policy_sub_list">
                {renderListItem("a. Register for profile assignment")}
                {renderListItem(
                  "b. Subscribe to newsletters, alerts or other services from us"
                )}
                {renderListItem(
                  "c. Ask us for more information about a product or service or contact us with a question or complaint"
                )}
                {renderListItem("d. Take part in a survey")}
                {renderListItem(
                  "e. Use our application and other products or services"
                )}
                {renderListItem("f. Visit or browse our website")}
              </div>
              <p className="privacy_policy_paragraph">
                With your permission or consent and/or as permitted by law, we
                may also collect information about you from other organizations
                or third parties, if this is appropriate and allowed by law.
                These include fraud-prevention agencies, business directories,
                and credit reference agencies.
              </p>
              <p className="privacy_policy_paragraph">
                Your information is added to our database and this information
                is then used to contact you about your interest in our goods or
                services and interact with the company.
              </p>
              <p className="privacy_policy_paragraph">
                We use mobile analytics software to allow us to better
                understand the functionality of our Mobile Apps on your mobile
                device. This software may record information such as how often
                you use the application, the events that occur within the
                application, aggregated usage, performance data, and where the
                application was downloaded from.
              </p>
              <p className="privacy_policy_paragraph">
                In addition to information, we collect on our websites, when you
                use our Mobile Apps, we may also collect your city location,
                device model and version, device identifier (or "UDID"), OS
                version, and your Subscription Service credentials. We send push
                notifications from time to time to update you about events or
                promotions. We may link information we store within the
                analytics software to Personal Information you submit within the
                Mobile App. We do this to improve the services we offer you and
                improve our marketing, analytics and site functionality.
              </p>
            </section>

            {/* Section 2: Unsubscribe */}
            <section className="privacy_policy_section" id="section-2">
              <h2 className="privacy_policy_section_header">
                2. To Unsubscribe from Our Communications
              </h2>
              <p className="privacy_policy_paragraph">
                If you no longer wish to receive such communications such ads/
                marketing messages from us, you may unsubscribe by contacting
                our customer services team or utilize any of the opt out turning
                them off at the device level, or clicking on the "unsubscribe"
                link located on the bottom of our e-mails, or through the
                Contact Us page on our website or our App). You will also be
                able to update your communication preferences, or by sending us
                emails.
              </p>
              <p className="privacy_policy_paragraph">
                If you choose to unsubscribe or opt out, we will hold your
                contact details on the file marked so that we do not contact you
                again. This is so that we do not contact you if your details are
                subsequently provided to us by a third party.
              </p>
              <p className="privacy_policy_paragraph">
                You however cannot opt out of receiving transactional emails
                related to your account with us or the Subscription Service.
              </p>
            </section>

            {/* Section 3: Personal Information Corrections */}
            <section className="privacy_policy_section" id="section-3">
              <h2 className="privacy_policy_section_header">
                3. Corrections of Personal Information
              </h2>
              <p className="privacy_policy_paragraph">
                You may access, correct, amend, and delete your personal
                information or object to the processing of your personal
                information in writing by sending us an email.
              </p>
              <p className="privacy_policy_paragraph">
                Upon receipt of your written request and enough information to
                permit us to identify your personal information, we will
                disclose to you the personal information we hold about you.
              </p>
              {renderListItem(
                "• We will also correct, amend or delete any personal information that you tell us is inaccurate and notify any third-party recipients of the necessary changes. You may update any information you have given to us by contacting us at our registered address."
              )}
              {renderListItem(
                "• Requests to delete personal information are subject to any applicable legal and ethical reporting or document retention obligations imposed on us."
              )}
            </section>

            {/* Section 4: Information Collection */}
            <section className="privacy_policy_section" id="section-4">
              <h2 className="privacy_policy_section_header">
                4. Information We Collect
              </h2>

              <h3 className="privacy_policy_sub_header" id="section-4-1">
                a. Personal Information
              </h3>
              <p className="privacy_policy_paragraph">
                The information we may collect about you depends on your use of
                our application. (We collect personal information of all our
                users). This refers to any information that you voluntarily
                submit to us and that identifies you personally, including
                contact information, such as your name, e-mail address, phone
                number, and other information about yourself. Personal
                Information can also include information about any transactions,
                both free and paid, that you enter into on the Websites, and
                information about you that is available on the internet, such as
                from Facebook, Instagram, LinkedIn, Twitter and Google, or
                publicly available information that we acquire from service
                providers. Your contact with us – such as:
              </p>
              <div className="privacy_policy_sub_list">
                {renderListItem(
                  "• The phone numbers that you call or send messages to (or the phone numbers that you receive these calls and messages from);"
                )}
                {renderListItem(
                  "• The date, time and length of the calls and messages you send or receive through our application, and your approximate location at the time these communications take place;"
                )}
                {renderListItem("• The level of service you receive")}
                {renderListItem(
                  "• Your website browsing information (which includes information about the websites you visit), and about how you use our website on your mobile or a PC;"
                )}
                {renderListItem(
                  "• The date, time and length of your internet browsing, and your approximate location at the time of browsing;"
                )}
                {renderListItem(
                  "• Your location and contact list on your mobile phone when using our apps and platforms."
                )}
              </div>
              <p className="privacy_policy_paragraph">
                Personal Information also includes Navigational Information or
                Payment Information where such information can directly or
                indirectly identify an individual. Navigational information
                refers to information about your computer and your visits to
                this website such as your IP address, geographical location,
                browser type, referral source, length of visit and pages viewed.
                Please see the "Navigation Information" section below. We
                collect and process payment information from you when payment is
                made via our platform, including credit and debit card numbers
                and billing information, using third party PCI-compliant service
                providers. Except for this, we do not collect Sensitive
                Information from you.
              </p>

              <h3 className="privacy_policy_sub_header" id="section-4-2">
                b. Information we collect from third parties
              </h3>
              <p className="privacy_policy_paragraph">
                From time to time, we may receive Personal Information about you
                from third party sources including partners with which engage in
                joint marketing activities, and publicly available sources such
                as social media websites.
              </p>

              <h3 className="privacy_policy_sub_header" id="section-4-3">
                c. Information About Children
              </h3>
              <p className="privacy_policy_paragraph">
                The Websites are not intended for or targeted at children under
                16, and we do not knowingly or intentionally collect information
                about children under 16. If you believe that we have collected
                information about a child under 16, please contact us so that we
                may delete the information.
              </p>
            </section>

            {/* Section 5: Information Usage */}
            <section className="privacy_policy_section" id="section-5">
              <h2 className="privacy_policy_section_header">
                5. How We Use Information We Collect
              </h2>
              <p className="privacy_policy_paragraph">
                We use the information we collect only in compliance with this
                Privacy Policy. Customers who subscribe to our Services
                (register on our website) are obligated through our agreements
                with them to comply with this Privacy Policy. We will never sell
                your Personal Information to any third party.
              </p>
              <p className="privacy_policy_paragraph">
                In addition to the uses identified elsewhere in this Privacy
                Policy, we may use your Personal Information to:
              </p>
              <div className="privacy_policy_sub_list">
                {renderListItem(
                  "• Improve your browsing experience by personalizing the Websites and to improve the Subscription Service"
                )}
                {renderListItem(
                  "• Send information or content to you which we think may be of interest to you by post, email, or other means and send you marketing communications relating to our business"
                )}
                {renderListItem(
                  "• Promote use of our services to you and share promotional and information content with you in accordance with your communication preferences"
                )}
                {renderListItem(
                  "• Provide other companies with statistical information about our users — but this information will not be used to identify any individual user"
                )}
                {renderListItem(
                  "• Send information to you regarding changes to our Customer Terms of Service, Privacy Policy (including the Cookie Policy), or other legal agreements"
                )}
                {renderListItem("• Meet legal requirements")}
                {renderListItem(
                  "• Process the goods and services you've bought from us, and keep you updated with your order progress"
                )}
                {renderListItem(
                  "• Keep you informed generally about new products and services (unless you choose not to receive our marketing messages)"
                )}
                {renderListItem(
                  "• Provide the relevant service or product to you, including services that use location information"
                )}
                {renderListItem(
                  "• Contact you with offers or promotions based on how you use our products and services"
                )}
                {renderListItem(
                  "• Bill you for using our products or services"
                )}
                {renderListItem(
                  "• Administer this Website and help us improve our services"
                )}
                {renderListItem(
                  "• Respond to any questions or concerns you may have"
                )}
                {renderListItem(
                  "• Protect our application and manage usage volume"
                )}
                {renderListItem(
                  "• Understand how you use our services to develop better products"
                )}
                {renderListItem(
                  "• Carry out research and statistical analysis"
                )}
                {renderListItem("• Prevent and detect fraud or other crimes")}
                {renderListItem(
                  "• Provide aggregated reports to third parties"
                )}
              </div>
              <p className="privacy_policy_paragraph">
                We will store your information for as long as we must by law. If
                there is no legal requirement, we will only store it for as long
                as we need it.
              </p>
            </section>

            {/* Section 6: Information Sharing */}
            <section className="privacy_policy_section" id="section-6">
              <h2 className="privacy_policy_section_header">
                6. Sharing Your Personal Information
              </h2>
              <p className="privacy_policy_paragraph">
                As may be permitted or authorized by law we may share
                information about you with Partners or agents involved in
                delivering the products and services you've ordered or used.
                Other reasons for sharing your data include:
              </p>
              <div className="privacy_policy_sub_list">
                <div className="privacy_policy_list_item">
                  We may share information with:
                </div>
                {renderListItem(
                  "a. Credit reference, fraud prevention or business scoring agencies"
                )}
                {renderListItem(
                  "b. Debt collection agencies or other debt recovery organizations"
                )}
                {renderListItem(
                  "c. Law enforcement agencies, regulatory organizations, courts or other public authorities if required by law"
                )}
                {renderListItem(
                  "d. Emergency services (if you make an emergency call), including your approximate location"
                )}
                {renderListItem(
                  "e. To protect against fraud, defend our rights or property, or protect customer interests"
                )}
                {renderListItem(
                  "f. In case of merger, acquisition, or similar business transfer"
                )}
                {renderListItem(
                  "g. With your consent, partner organizations for their products and services"
                )}
                {renderListItem(
                  "h. To comply with legal requirements or protect security and integrity"
                )}
              </div>
              <p className="privacy_policy_paragraph">
                Where appropriate, before disclosing personal information to a
                third party, we contractually require the third party to take
                adequate precautions to protect that data and to comply with
                applicable law.
              </p>
            </section>

            <section className="privacy_policy_section" id="section-7">
              <h2 className="privacy_policy_section_header">
                7. Transfer of Information
              </h2>
              <p className="privacy_policy_paragraph">
                If you are visiting this Website, communications might result in
                the transfer of certain information across international
                boundaries. We ensure compliance with applicable data protection
                legislation when transferring information to affiliates or
                service providers.
              </p>
            </section>

            <section className="privacy_policy_section" id="section-8">
              <h2 className="privacy_policy_section_header">
                8. Security of Your Personal Information
              </h2>
              <p className="privacy_policy_paragraph">
                We use a variety of security technologies and procedures to help
                protect your Personal Information from unauthorized access, use
                or disclosure. We secure the information you provide on computer
                servers in a controlled, secure environment, protected from
                unauthorized access using appropriate physical, technical and
                organizational measures.
              </p>
            </section>

            <section className="privacy_policy_section" id="section-9">
              <h2 className="privacy_policy_section_header">
                9. Cookies and Similar Technologies
              </h2>
              <p className="privacy_policy_paragraph">
                We use cookies to analyze trends, administer the website, track
                users' movements around the website, and gather demographic
                information about our user base. Cookies help us remember you
                and understand how you use our services.
              </p>
              <p className="privacy_policy_paragraph">
                You can set your browser to notify you when you receive a cookie
                and decide whether to accept it. However, choosing not to accept
                cookies may limit website functionality.
              </p>
            </section>

            <section className="privacy_policy_section" id="section-10">
              <h2 className="privacy_policy_section_header">
                10. Data Retention
              </h2>
              <p className="privacy_policy_paragraph">
                How long we keep information depends on the type of information.
                We retain Personal Information where we have an ongoing
                legitimate business need. When we no longer need the
                information, we securely delete or anonymize it.
              </p>
            </section>

            <section className="privacy_policy_section" id="section-11">
              <h2 className="privacy_policy_section_header">11. Your Rights</h2>
              <p className="privacy_policy_paragraph">
                You have the right to access, correct, update, or delete your
                personal information. You may also object to processing or
                request data portability where applicable. Contact us to
                exercise these rights.
              </p>
            </section>

            <section className="privacy_policy_section" id="section-12">
              <h2 className="privacy_policy_section_header">12. Contact Us</h2>
              <p className="privacy_policy_paragraph">
                If you have questions about this Privacy Policy or our data
                practices, please contact us. We welcome your feedback and will
                address any concerns promptly.
              </p>
            </section>

            <section className="privacy_policy_section" id="section-13">
              <h2 className="privacy_policy_section_header">
                13. Governing Law
              </h2>
              <p className="privacy_policy_paragraph">
                The laws of the Federal Republic of Nigeria will govern any
                dispute or claim arising out of or relating to your use of this
                Website.
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
